import {
  SHOW_LOGIN_MODAL,
  CLOSE_LOGIN_MODAL,
  SWITCH_TO_LOGIN,
  SWITCH_TO_REGISTER,
  SWITCH_TO_REGISTER_WITH_INVITATION,
  SWITCH_TO_FORGOT_PASSWORD,
  SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION,
  UPDATE_LOGIN_FIELD,
  UPDATE_REGISTER_FIELD,
  UPDATE_REGISTER_WITH_INVITATION_FIELD,
  UPDATE_FORGOT_PASSWORD_FIELD,
  UPDATE_RESET_PASSWORD_FIELD,
  UPDATE_LOGIN_ERROR,
  UPDATE_REGISTER_ERROR,
  UPDATE_FORGOT_PASSWORD_ERROR,
  UPDATE_RESET_PASSWORD_ERROR,
  START_LINKEDIN
} from '../actions/login.js'

const loginReducer = (
  state = {
    mainViewType: 'login',
    registerInfo: {},
    registerWithInvitationInfo: {},
    loginInfo: {},
    forgotPasswordInfo: {},
    resetPasswordInfo: {}
  },
  action
) => {
  switch (action.type) {
    case START_LINKEDIN:
      return {
        ...state,
        linkedINFlow: true
      }
    case SHOW_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal: true,
        mainViewType: 'login',
        loginInfo: {},
        registerInfo: {},
        error: undefined,
        loginError: undefined,
        registerError: undefined,
        forgotPasswordError: undefined,
        resetPasswordError: undefined
      }
    case CLOSE_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal: false,
        mainViewType: 'login'
      }
    case SWITCH_TO_REGISTER:
      return {
        ...state,
        loginInfo: {},
        registerInfo: {},
        forgotPasswordInfo: {},
        error: undefined,
        loginError: undefined,
        registerError: undefined,
        forgotPasswordError: undefined,
        resetPasswordError: undefined,
        mainViewType: 'register'
      }
    case SWITCH_TO_REGISTER_WITH_INVITATION:
      return {
        ...state,
        loginInfo: {},
        registerWithInvitationInfo: {},
        forgotPasswordInfo: {},
        error: undefined,
        loginError: undefined,
        registerError: undefined,
        forgotPasswordError: undefined,
        resetPasswordError: undefined,
        mainViewType: 'registerWithInvitation'
      }
    case SWITCH_TO_LOGIN:
      return {
        ...state,
        loginInfo: {},
        registerInfo: {},
        forgotPasswordInfo: {},
        error: undefined,
        loginError: undefined,
        registerError: undefined,
        forgotPasswordError: undefined,
        resetPasswordError: undefined,
        mainViewType: 'login'
      }
    case SWITCH_TO_FORGOT_PASSWORD:
      return {
        ...state,
        loginInfo: {},
        registerInfo: {},
        forgotPasswordInfo: {},
        error: undefined,
        loginError: undefined,
        registerError: undefined,
        forgotPasswordError: undefined,
        resetPasswordError: undefined,
        mainViewType: 'forgot'
      }
    case SWITCH_TO_FORGOT_PASSWORD_CONFIRMATION:
      return {
        ...state,
        confirmMessage: action.confirmMessage,
        mainViewType: 'confirmation'
      }
    case UPDATE_LOGIN_FIELD:
      return {
        ...state,
        loginInfo: { ...state.loginInfo, [action.name]: action.value }
      }
    case UPDATE_REGISTER_FIELD:
      return {
        ...state,
        registerInfo: { ...state.registerInfo, [action.name]: action.value }
      }
    case UPDATE_REGISTER_WITH_INVITATION_FIELD:
      return {
        ...state,
        registerWithInvitationInfo: { ...state.registerWithInvitationInfo, [action.name]: action.value }
      }
    case UPDATE_FORGOT_PASSWORD_FIELD:
      return {
        ...state,
        forgotPasswordInfo: { ...state.forgotPasswordInfo, [action.name]: action.value }
      }
    case UPDATE_RESET_PASSWORD_FIELD:
      return {
        ...state,
        resetPasswordInfo: { ...state.resetPasswordInfo, [action.name]: action.value }
      }
    case UPDATE_REGISTER_ERROR:
      return {
        ...state,
        registerError: action.error
      }
    case UPDATE_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.error
      }
    case UPDATE_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        forgotPasswordError: action.error
      }

    case UPDATE_RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordError: action.error
      }

    default:
      return {
        ...state,
        showLoginModal: true
      }
  }
}

export default loginReducer



// WEBPACK FOOTER //
// ./src/reducers/login.js